const step = 16
const parts = 8

export const strHash = (str: string): string => {
  if (!str) {
    return ''
  }

  let hash = ''

  for (let i = 0; i < parts; i++) {
    if (i === parts - 1) {
      hash += strHashPart(str.slice(i * step))
    } else {
      const sl = str.slice(i * step, (i + 1) * step)
      hash += strHashPart(sl)
    }

    if ((i + 1) * step >= str.length) {
      break
    }
  }

  return hash
}

const strHashPart = (str: string): string => {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0 // Convert to 32bit integer
  }
  return Math.abs(hash).toString(16)
}
